import { useEffect, useState, useMemo } from 'react';
import { Map, Marker, useApiIsLoaded } from '@vis.gl/react-google-maps';
import { formatGeneralAddress } from '@components/BookingDetails/utils';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { Box, useMediaQuery } from '@gemini/fe-ds-core';
import { TabletBreakpoint } from '@utils/consts/breakpoints.consts';
import { useTranslation } from 'react-i18next';

interface DirectionsCardMapProps {
  isStatic?: boolean;
}

export function DirectionsCardMap({
  isStatic = false,
}: DirectionsCardMapProps) {
  const { t } = useTranslation();
  const practiceInfo = useOnlineBookingStore(state => state.generalInfo);
  const address = useMemo(
    () => formatGeneralAddress(practiceInfo),
    [practiceInfo],
  );
  const isMobile = useMediaQuery(`(max-width:${TabletBreakpoint}px)`);

  const apiIsLoaded = useApiIsLoaded();
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [center, setCenter] = useState<{ lat: number; lng: number } | null>(
    null,
  );

  useEffect(() => {
    if (!apiIsLoaded) return;
    if (!address) {
      setError('error loading map');
      setLoading(false);
      return;
    }

    try {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address }, (results, status) => {
        if (
          status === google.maps.GeocoderStatus.OK &&
          results?.[0]?.geometry?.location
        ) {
          const loc = results[0].geometry.location;
          setCenter({ lat: loc.lat(), lng: loc.lng() });
        } else {
          setError('error loading map');
        }
      });
    } catch {
      setError('error loading map');
    } finally {
      setLoading(false);
    }
  }, [apiIsLoaded, address]);

  return (
    <Box style={{ width: '100%', height: isMobile ? 360 : '100%' }}>
      {/* {isLoading && <LuxLoader size="large" />} */}
      {!isLoading && error && (
        <Box
          display={'flex'}
          height={'100%'}
          width={'100%'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          {t('practiceCard.errorLoadingMap')}
        </Box>
      )}
      {!error && center && (
        <Map
          defaultCenter={center}
          defaultZoom={15}
          mapTypeControl={false} // no toggle "Mappa / Satellite"
          streetViewControl={false} // no omino di Street View
          fullscreenControl={false} // no pulsante "schermo intero"
          zoomControl={false} // no pulsanti + e -
          keyboardShortcuts={false} // no scorciatoie tastiera
          clickableIcons={false} // no clic su POI e icone
          style={{ width: '100%', height: '100%' }}
          //per bloccare navigazione
          gestureHandling={isStatic ? 'none' : 'auto'}
          disableDoubleClickZoom={isStatic}
        >
          <Marker
            position={center}
            title={address}
            // label={{
            //   text: practiceInfo?.name || '',
            //   color: 'black',
            //   fontSize: '14px',
            //   fontWeight: 'bold',
            // }}
            // icon={{
            //   url: 'https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2_hdpi.png', // pin classico
            //   scaledSize: new google.maps.Size(40, 40),
            //   labelOrigin: new google.maps.Point(60, 20), // sposto label a destra
            // }}
          />
        </Map>
      )}
    </Box>
  );
}
